import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Slider from "react-slick";
import LeftIcon from "../../../../Assets/images/icon/left.svg"
import RightIcon from "../../../../Assets/images/icon/right.svg"
import RingImg from "../../../../Assets/images/home/ring-category.webp"
import BraceletImg from "../../../../Assets/images/home/bracelete.svg"
import NacklessImg from "../../../../Assets/images/home/neckless.svg"
import EarringImg from "../../../../Assets/images/home/Earrings.jpg"
import PendantImg from "../../../../Assets/images/home/pendant-sin.jpg"
import { useTranslation } from 'react-i18next'
import LocalizedLink from "../../../../Components/LocalizedLink";
const ExploreCollection = () => {
     const { t } = useTranslation()
  const LeftArrow = (props) => {
    return (
      <div className="slick-arrow slick-prev" {...props}>
        <img src={LeftIcon} alt="Left Arrow" />
      </div>
    );
  };

  const RightArrow = (props) => {
    return (
      <div className="slick-arrow slick-next" {...props}>
        <img src={RightIcon} alt="Right Arrow" />
      </div>
    );
  };


  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <LeftArrow />,
    nextArrow: <RightArrow />,
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="explore-collection section-space">
      <Container fluid className="home-showcase-container">
        <Heading>
          <h2>{(t('exploreCollection.heading'))}</h2>
          <p>{(t('exploreCollection.subheading'))}</p>
        </Heading>

        <div className="inner-shop-diamond-shape">
          <div className="diamonds-collection">
            <Slider {...settings}>
              {/* {data.map((item, i) => (
                  <div
                    className="diamond-item cursor-pointer"
                    key={i}
                    onClick={() => setDiamondItem(item)}
                  >
                    <Image  loading="lazy" src={item.image} alt="Round" />
                    <p className={`${item.name === item.name && "name"}`}>
                      {item.name}
                    </p>
                     
                  </div>
                ))} */}

              {/* <div className="item text-center">
                <div className="box-overlay"></div>
                <LocalizedLink to="/fashion-rings" className="img-box">
                  <Image  loading="lazy" src={RingImg} alt="Ring" />
                </LocalizedLink>
                <LocalizedLink to="/fashion-rings" className="link">Rings</LocalizedLink>
              </div> */}

              <div className="item text-center">
                <div className="box-overlay"></div>
                <LocalizedLink to="/fine-jewelry/bracelets" className="img-box">
                  <Image  loading="lazy" src={BraceletImg} alt="Bracelet" />
                </LocalizedLink>
                <LocalizedLink to="/fine-jewelry/bracelets" className="link"><h2>{(t('exploreCollection.categories.bracelets'))}</h2></LocalizedLink>
              </div>
              {/* <div className="item text-center">
                <div className="box-overlay"></div>
                <LocalizedLink to="/pendants" className="img-box"> 
                  <Image  loading="lazy" src={PendantImg} alt="Bracelet" />
                </LocalizedLink>
                <LocalizedLink to="/pendants" className="link">Pendants</LocalizedLink>
              </div> */}
              <div className="item text-center">
                <div className="box-overlay"></div>
                <LocalizedLink to="/fine-jewelry/earrings" className="img-box">
                  <Image loading="lazy" src={EarringImg} alt="Earring" />
                </LocalizedLink>
                <LocalizedLink to="/fine-jewelry/earrings" className="link"><h2>{(t('exploreCollection.categories.earings'))}</h2></LocalizedLink>
              </div>

              <div className="item text-center">
                <div className="box-overlay"></div>
                <LocalizedLink to="/fine-jewelry/pendants" className="img-box">
                  <Image  loading="lazy" src={PendantImg} alt="Necklace" />
                </LocalizedLink>
                <LocalizedLink to="/fine-jewelry/pendants" className="link"><h2>{(t('exploreCollection.categories.pendants'))}</h2></LocalizedLink>
              </div>
            </Slider>
          </div>
        </div>

        {/* <Row>

          <Col md={3} xs={6}>
            <div className="item text-center">
              <LocalizedLink to="/fashion-rings" className="img-box">
                <Image  loading="lazy" src={Ring} alt="Ring" />
              </LocalizedLink>
              <LocalizedLink to="/fashion-rings">Rings</LocalizedLink>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <LocalizedLink to="/bracelets" className="img-box">
                <Image  loading="lazy" src={Bracelet} alt="Bracelet" />
              </LocalizedLink>
              <LocalizedLink to="/bracelets">Bracelets</LocalizedLink>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <LocalizedLink to="/earrings" className="img-box">
                <Image  loading="lazy" src={Earring} alt="Earring" />
              </LocalizedLink>
              <LocalizedLink to="/earrings">Earrings</LocalizedLink>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <LocalizedLink to="/necklaces" className="img-box">
                <Image  loading="lazy" src={Necklace} alt="Necklace" />
              </LocalizedLink>
              <LocalizedLink to="/necklaces">Necklaces</LocalizedLink>
            </div>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
};

export default ExploreCollection;
